module.exports = __webpack_public_path__ + "img/020.181020a9.png";